import PropTypes from 'prop-types';
import { clsx } from 'clsx';

const variantStyles = {
  ghost: 'hover:bg-bg-hover hover:cursor-pointer',
  bordered: 'border border-border-default hover:bg-bg-hover hover:cursor-pointer',
  accent: 'bg-accent text-tertiary hover:bg-hover active:bg-pressed hover:cursor-pointer',
};

const sizeStyles = {
  sm: 'p-spacing-1',
  md: 'p-spacing-2',
  lg: 'p-spacing-3',
};

const borderedSizeStyles = {
  sm: 'p-[3px]', // 4px - 1px border
  md: 'p-[7px]', // 8px - 1px border
  lg: 'p-[11px]', // 12px - 1px border
};

const roundedStyles = {
  full: 'rounded-full',
  sm: 'rounded',
};

const focusStyles = {
  ring: 'focus-visible:ring-2 focus-visible:ring-accent focus-visible:outline-none',
  subtle: 'focus:outline-none focus:bg-bg-hover',
};

export function IconButton({
  children,
  variant = 'ghost',
  size = 'md',
  rounded = 'full',
  focusStyle = 'ring',
  disabled = false,
  className = '',
  onClick,
  onFocus,
  onBlur,
  'aria-label': ariaLabel,
  'aria-describedby': ariaDescribedBy,
  type = 'button',
  ...props
}) {
  return (
    <button
      type={type}
      onClick={onClick}
      onFocus={onFocus}
      onBlur={onBlur}
      disabled={disabled}
      aria-label={ariaLabel}
      aria-describedby={ariaDescribedBy}
      className={clsx(
        'inline-flex items-center justify-center',
        'transition-colors duration-200 hover:cursor-pointer',
        focusStyles[focusStyle],
        variantStyles[variant],
        variant === 'bordered' ? borderedSizeStyles[size] : sizeStyles[size],
        roundedStyles[rounded],
        disabled && 'opacity-50 cursor-not-allowed',
        className
      )}
      {...props}
    >
      <span className="size-4">{children}</span>
    </button>
  );
}

IconButton.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['ghost', 'bordered', 'accent']),
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  rounded: PropTypes.oneOf(['full', 'sm']),
  focusStyle: PropTypes.oneOf(['ring', 'subtle']),
  disabled: PropTypes.bool,
  className: PropTypes.string,
  onClick: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  'aria-label': PropTypes.string,
  'aria-describedby': PropTypes.string,
  type: PropTypes.string,
};
